import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';


@Component({
  selector: 'page-cek-senet-detay',
  templateUrl: 'cek-senet-detay.html',
})
export class CekSenetDetayPage {
item:any={ID:"",CekSenetNo:"",CekSenetTur:"",AlinmaTarihi:"",VadeTarihi:"",Banka:"",HesapNo:""
,Iban:"",Tutar:"",CekSenetAsilSahibi:"",DurumAdi:"",CariAdi:"",Aciklama:""};
  constructor(public navCtrl: NavController,
public viewCtrl:ViewController,
     public navParams: NavParams) {
      if (navParams.get("item") != null) {
        this.item = navParams.get("item");
      }
  }

  ionViewDidLoad() {
   
  }
kapat()
{
  this.viewCtrl.dismiss();
}
}



// WEBPACK FOOTER //
// ./src/pages/CekSenetIslemleri/cek-senet-detay/cek-senet-detay.ts